import api from '@/services/api/api';

export const useAudioCoursesBySlug = (slug) => {
  const audioCourse = useQuery(
    ['audioCourse', slug],
    async () => {
      const { data } = await api.courses.getCourseBySlug(slug);
      return data;
    },
    {
      staleTime: Infinity,
      select: (data) => ({ data: data?.data, course: data?.course }),
    },
  );

  onServerPrefetch(async () => {
    await audioCourse.suspense();
  });

  return {
    audioCourse,
  };
};
